import { useMemo } from "react";
import usePageMeta from "@/hooks/usePageMeta";
import HeroSection from "@/pages/home/components/HeroSection";
import HotEventsSection from "@/pages/home/components/HotEventsSection";
import TimelineSpotlightSection from "@/pages/home/components/TimelineSpotlightSection";
import CategoriesSection from "@/pages/home/components/CategoriesSection";
import LatestEventsSection from "@/pages/home/components/LatestEventsSection";
import RankingSection from "@/pages/home/components/RankingSection";
import FaqSection from "@/pages/home/components/FaqSection";
import NewsletterSection from "@/pages/home/components/NewsletterSection";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.fullName,
        description: siteInfo.description,
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        description: siteInfo.description,
        email: siteInfo.email,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
    []
  );

  usePageMeta({
    title: "瓜线｜热门吃瓜来龙去脉 时间线梳理 前因后果全程复盘",
    description:
      "瓜线专注热门吃瓜来龙去脉整理，提供热门吃瓜时间线与前因后果复盘。每个事件按关键节点逐步拆解，帮你理清人物关系与剧情反转，不再吃残瓜。",
    keywords: "热门吃瓜,热门吃瓜来龙去脉,热门吃瓜时间线,热门吃瓜前因后果,热门吃瓜全程复盘,热门吃瓜长文梳理",
    path: "/",
    jsonLd,
  });

  return (
    <>
      <HeroSection />
      <HotEventsSection />
      <TimelineSpotlightSection />
      <CategoriesSection />
      <LatestEventsSection />
      <RankingSection />
      <FaqSection />
      <NewsletterSection />
    </>
  );
}